import { logError } from '@/utils/logger.utils';
import { ApiTypes } from '@/types/server/api.types';

export const handleLogout = async () => {
	try {
		const response = await fetch(
			`${import.meta.env.VITE_SERVER_API_PREFIX}/candidates/logout`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${window.localStorage.getItem('token')}`,
				},
			}
		);

		const data = (await response.json()) as ApiTypes.TLogoutCandidateResponse;

		if (data.httpResponseCode !== 200) {
			throw new Error(data.message);
		}
	} catch (err) {
		logError(err);
	} finally {
		window.localStorage.removeItem('token');
	}
};
